module.exports = __webpack_public_path__ + "img/image4.d0b19892.png";